import { render, staticRenderFns } from "./NewCommunity.vue?vue&type=template&id=e9e64fce&"
import script from "./NewCommunity.vue?vue&type=script&lang=js&"
export * from "./NewCommunity.vue?vue&type=script&lang=js&"
import style0 from "./NewCommunity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports